import { dogfoodContext as getDogfoodContext, secureModeContextHash } from '@gonfalon/constants/constants';
import type { LDClient as LDClientV4 } from '@launchdarkly/js-client-sdk';
import { cloneDeep } from 'lodash';

import { isDogfoodClientV4 } from './getDogfoodClient';
import { waitForDogfoodClient } from './waitForDogfoodClient';

type Attributes = {
  [key: string]: string | number | boolean;
};

export async function identifyWithAttributes(attributesByKind: { [contextKind: string]: Attributes }) {
  const ldClient = await waitForDogfoodClient();
  const dogfoodContext = getDogfoodContext();

  if ('kind' in dogfoodContext) {
    if (dogfoodContext.kind === 'user') {
      // context is single kinded user - also not expected to happen in practice
      const newContext = 'user' in attributesByKind ? { ...dogfoodContext, ...attributesByKind.user } : dogfoodContext;
      if (isDogfoodClientV4()) {
        return (ldClient as LDClientV4).identify(newContext, { hash: secureModeContextHash() });
      } else {
        return ldClient.identify(newContext, secureModeContextHash());
      }
    } else if (dogfoodContext.kind === 'multi') {
      Object.keys(attributesByKind).forEach((contextKind) => {
        if (!Object.prototype.hasOwnProperty.call(dogfoodContext, contextKind)) {
          /* eslint-disable-next-line no-console */
          console.error(`Cannot add attribute(s) to missing '${contextKind}' context`);
        }
      });
      const newContext = Object.keys(attributesByKind).reduce(
        (acc, contextKind) => ({
          ...acc,
          [contextKind]: { ...acc[contextKind], ...attributesByKind[contextKind] },
        }),
        cloneDeep(dogfoodContext),
      );
      if (isDogfoodClientV4()) {
        return (ldClient as LDClientV4).identify(newContext, { hash: secureModeContextHash() });
      } else {
        return ldClient.identify(newContext, secureModeContextHash());
      }
    }
  }

  throw new Error('Dogfood context does not match expected schema');
}
